import { useTranslation } from 'react-i18next'
import { Button, Paper, Stack } from '@mui/material'
import { Sync as SyncIcon, Refresh as RefreshIcon, PlayArrow as PlayIcon, Clear as ClearIcon, DeleteForever as DeleteForeverIcon } from '@mui/icons-material'
import { SyncStatus } from '@/core/offline/types/database.types'

type ActionButtonsProps = {
  onManualSync: () => void
  onRetryFailed: () => void
  onClearCompleted: () => void
  onRefresh: () => void
  onClearOfflineData: () => void
  loading: boolean
  syncStatus: SyncStatus
}

export function ActionButtons({ onManualSync, onRetryFailed, onClearCompleted, onRefresh, onClearOfflineData, loading, syncStatus }: ActionButtonsProps) {
  const { t } = useTranslation()

  return (
    <Paper sx={{ p: 2 }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} flexWrap="wrap" gap={2}>
        <Button variant="contained" startIcon={<SyncIcon />} onClick={onManualSync} disabled={loading || syncStatus.isActive}>
          {t('sync.syncNow')}
        </Button>
        <Button variant="outlined" startIcon={<PlayIcon />} onClick={onRetryFailed} disabled={loading || syncStatus.failedCount === 0}>
          {t('sync.retryFailed')}
        </Button>
        <Button variant="outlined" startIcon={<ClearIcon />} onClick={onClearCompleted} disabled={loading || syncStatus.completedCount === 0}>
          {t('sync.clearCompleted')}
        </Button>
        <Button variant="outlined" startIcon={<RefreshIcon />} onClick={onRefresh} disabled={loading}>
          {t('sync.refresh')}
        </Button>
        <Button variant="outlined" color="error" startIcon={<DeleteForeverIcon />} onClick={onClearOfflineData} disabled={loading}>
          {t('sync.clearOfflineData')}
        </Button>
      </Stack>
    </Paper>
  )
}
